import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      // Best-effort SW register + push subscribe (silent — never blocks the app).
      import("@/lib/push").then(({ registerSwAndSubscribe }) => registerSwAndSubscribe({ silent: true })).catch(() => {});
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip check if returning from OAuth callback - AuthCallback handles session
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    try { navigator.serviceWorker?.controller?.postMessage({ type: "F2N_LOGOUT" }); } catch {}
    setUser(null);
  };

  const setMobile = async (mobile) => {
    await api.post("/auth/mobile", { mobile });
    setUser((u) => u ? { ...u, mobile } : u);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout, setMobile }}>
      {children}
    </AuthContext.Provider>
  );
}
